import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ConfigProvider, Flex, Switch, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useReactToPrint } from 'react-to-print';
import { useAppSelector } from '../../../app/hooks';
import { selectUser } from '../../../auth/states/userSlice';
import { Fixed2, formatAmount } from '../../../common/utils/common.utils';
import BreadCrumb from '../../../components/common/breadCrumb/BreadCrumb';
import CommonViewReport from '../../../components/common/Invoice/ViewInvoiceInfo/CommonViewReport';
import Reload from '../../../components/common/reload/Reload';
import { loadingIndicator } from '../../../components/common/spinner/LoadingIndicator';
import { iconStyle } from '../../../layout/pages/Sidebar';
import { landscapePageStyle } from '../../Reports/ledgers/pages/ClientLedgers';
import { useBspUpcomingPaymentQuery } from '../Api/Endpoints/DashboardEndpoints';
import ConsolidateRemittanceModal from '../Components/BSP/ConsolidateRemittanceModal';
import { IBSPUpcomingPaymentConsolidate } from '../interfaces/dashboard.interfaces';
import IataBspModal from './IataBspModal';

const { Text } = Typography;
const BSPUpcomingPayment = () => {
  const componentRef = useRef(null);
  const navigate = useNavigate();
  const [bspPeriod, setBspPeriod] = useState('');
  const [iata, setIata] = useState('');

  const user = useAppSelector(selectUser);

  const currency = useAppSelector((state) => state.user?.organization_info.org_currency);
  const { data, isLoading, refetch: refetchBsp, isFetching } = useBspUpcomingPaymentQuery();
  console.log(data);

  // const updatedConsolidated: any[] = [];

  // data?.data?.reduce((prev, curr, index) => {
  //   if (index > 0) {
  //     updatedConsolidated.push({
  //       ...curr,
  //       bsp_paid: Number(curr?.bsp_paid) + Number(prev?.bsp_extra_paid),
  //     });
  //   }

  //   return curr;
  // }, {} as IBSPUpcomingPaymentConsolidate);

  const column = (isPrint: boolean = false): ColumnsType<IBSPUpcomingPaymentConsolidate> => {
    return [
      {
        title: 'Period',
        render: (record) => (
          <Text style={{ cursor: 'pointer' }} onClick={() => setIata(record)} strong>
            {record?.bsp_period}
          </Text>
        ),
      },
      {
        title: 'Remittance Date',
        key: 'remittance_date',
        dataIndex: 'remittance_date',
        render: (curr) => (
          <Text style={{ cursor: 'pointer' }}>{dayjs(curr).format('DD MMM YYYY')} </Text>
        ),
      },
      {
        title: 'Amount to be paid',
        render: (rec) => {
          const balance = Fixed2(rec.amount_to_be_paid);
          return (
            <div
              style={{
                display: 'inline-block',
                width: '120px',
                textAlign: 'left',
                whiteSpace: 'nowrap',
              }}
            >
              {currency?.toUpperCase()} {formatAmount(balance)}
            </div>
          );
        },
      },
      {
        title: 'Paid',
        render: (rec) => {
          const balance = Fixed2(rec.bsp_paid);
          return (
            <div
              style={{
                display: 'inline-block',
                width: '120px',
                textAlign: 'left',
                whiteSpace: 'nowrap',
              }}
            >
              {currency?.toUpperCase()} {formatAmount(balance)}
            </div>
          );
        },
      },

      {
        title: 'Balance',
        render: (curr, rec, index) => {
          const balance =
            Fixed2(rec.total_issue_amount) - Fixed2(rec.total_refund_amount) - Fixed2(rec.bsp_paid);

          const finalBalance = index === 0 ? balance : balance + Number(rec?.bsp_extra_paid || 0);

          return (
            <div
              style={{
                display: 'inline-block',
                width: '120px',
                textAlign: 'left',
                whiteSpace: 'nowrap',
              }}
            >
              {currency?.toUpperCase()} {formatAmount(finalBalance)}
            </div>
          );
        },
      },
      {
        title: 'Status',
        render: (curr, rec) => {
          const balance =
            Fixed2(rec.total_issue_amount) -
            Fixed2(rec.total_refund_amount) -
            Fixed2(rec.bsp_paid) +
            Number(rec?.bsp_extra_paid || 0);
          return (
            <div
              style={{
                width: '150px', // Fixed width
                height: '32px', // Fixed height
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                marginBottom: '10px',
                marginTop: '10px',
              }}
            >
              {balance <= 0 ? (
                <Text
                  strong
                  style={{
                    background: '#b8e9b2',
                    color: 'black',
                    padding: '4px 15px',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  PAYMENT COMPLETED
                </Text>
              ) : (
                <Text
                  strong
                  style={{
                    background: '#f6c636',
                    color: 'black',
                    padding: '4px 15px',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  PENDING
                </Text>
              )}
            </div>
          );
        },
      },
      {
        title: 'Action',
        align: 'center',
        hidden: isPrint,
        render: (curr, rec) => {
          return (
            <FontAwesomeIcon
              onClick={() => setBspPeriod(rec.bsp_period)}
              style={{
                ...iconStyle,
                border: '1px solid lightgrey',
                padding: '5px',
                borderRadius: '100%',
                fontSize: '16px',
                cursor: 'pointer',
              }}
              icon={faPaperclip}
            />
          );
        },
      },
    ];
  };

  const jsx = (isPrint: boolean = false) => (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBorderRadius: 0,
            rowHoverBg: '#343a401e',
            headerBg: '',
          },
        },
      }}
    >
      <Table
        scroll={{ x: 'max-content' }}
        // rowClassName={(record) => {
        //   console.log(record);
        //   const { total_issue_amount, total_refund_amount, bsp_paid, bsp_extra_paid } = record;

        //   const balance =
        //     Fixed2(total_issue_amount) -
        //     Fixed2(total_refund_amount) -
        //     Fixed2(bsp_paid) +
        //     Number(bsp_extra_paid || 0);
        //   const paid = bsp_paid + Number(bsp_extra_paid || 0);
        //   let className = '';

        //   if (balance <= 0) return (className = 'void_inv-row-style');
        //   if (balance > 0 && parseFloat(paid) > 0) return (className = 'refund-row-style');

        //   return className;
        // }}
        loading={{
          spinning: isLoading || isFetching,
          indicator: loadingIndicator,
        }}
        dataSource={data?.data}
        columns={column(isPrint)}
        pagination={false}
        size='small'
        prefixCls='custom_bsp_table'
      />
    </ConfigProvider>
  );

  const print_content = (isPrint: boolean = false) => {
    return (
      <div hidden>
        <CommonViewReport
          children={jsx(isPrint)}
          printRef={componentRef}
          title={{
            info_title: 'Upcoming BSP Payment List',
            title: 'Upcoming BSP Payment List',
          }}
        />
      </div>
    );
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Upcoming_BSP_Payment_List',
    pageStyle: landscapePageStyle,
  });

  return (
    <>
      <BreadCrumb arrOfOption={[`${user?.organization_info.org_name} - Consolidated`]} />
      <ConsolidateRemittanceModal
        bsp_period={bspPeriod}
        setBspPeriod={setBspPeriod}
        bspPeriod={bspPeriod}
      />
      <IataBspModal setIata={setIata} iata={iata} />
      <Flex gap={10}>
        <Button onClick={() => navigate('../')} type='primary' icon={<ArrowLeftOutlined />}>
          Dashboard
        </Button>

        <Button onClick={handlePrint} type='primary' icon={<PrinterOutlined />}>
          Print
        </Button>
        <Reload
          refetch={() => {
            refetchBsp();
          }}
        />
      </Flex>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography.Title
          level={5}
          style={{
            fontFamily: 'inherit',
            fontWeight: 'bold',
            fontSize: 18,
            margin: '20px 0',
            textTransform: 'uppercase',
          }}
        >{`${user?.organization_info.org_name} - Consolidated`}</Typography.Title>
        <Typography.Title level={5}>
          Remittance Date Remainders <Switch size='small' />
        </Typography.Title>
      </div>
      {jsx(false)}
      {print_content(true)}
    </>
  );
};

export default BSPUpcomingPayment;
